<template>
    <div class="flex flex-col flex-1 px-4 pt-4 bg-white ">
        <div class="">
            <Door v-if="formStep == 1"/>
            <SidePanels v-if="formStep == 2"/>
            <BeamsUprights v-if="formStep == 3"/>
            <Frame v-if="formStep == 4"/>
            <Glass v-if="formStep == 5"/>
            <Handles v-if="formStep == 6"/>
        </div>
        <div class="mt-auto">
            <Buttons class=""></Buttons>
        </div>
    </div>
</template>

<script>
    import Door from '@/components/steps/Door.vue'
    import SidePanels from '@/components/steps/SidePanels.vue'
    import BeamsUprights from '@/components/steps/BeamsUprights.vue'
    import Handles from '@/components/steps/Handles.vue'
    import Glass from '@/components/steps/Glass.vue'
    import Frame from '@/components/steps/Frame.vue'

    import Buttons from '@/components/steps/Buttons'

    export default {
        components: {
            Door,
            SidePanels,
            BeamsUprights,
            Handles,
            Glass,
            Buttons,
            Frame
        },
        computed: {
            formStep() {
                return this.$store.state.formStep;
            }
        }
    }
</script>

<style>

</style>